import React from 'react';
import links from '../../../links';

export function AsideMenuList({layoutProps}) {

  return (
    <ul className={`menu-nav ${layoutProps.ulClasses}`}>
      {links.map((Link, ind) => <Link key={ind}/>)}
    </ul>
  );
}
